import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { Button, Alert } from 'react-bootstrap';
import { ImProfile } from "react-icons/im";
import { FaEdit } from "react-icons/fa";
import axios from 'axios';

function ResetPassword() {
    const navigate = useNavigate();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success'); // Default alert type

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (newPassword !== confirmPassword) {
            setAlertMessage('New passwords do not match');
            setAlertType('danger'); // Set alert type to danger for error message
            setShowAlert(true);
            return;
        }

        try {
            const userId = localStorage.getItem('userId');
            const response = await axios.post('https://backend.ems.uk.hiradentallab.com/api/user/reset-password', {
                userId,
                oldPassword,  // Include old password in the request if needed
                newPassword,
            });

            // Check if the update was successful
            if (response.status === 200) {
                setAlertMessage(response.data.message || 'Password reset successful!');
                setAlertType('success'); // Set alert type to success for success message
                setShowAlert(true);
                setTimeout(() => {
                    navigate('/account-settings'); // Navigate on success
                }, 3000); // Wait for 3 seconds before navigation
            }
        } catch (error) {
            setAlertMessage(error.response ? error.response.data.message : 'Server error');
            setAlertType('danger'); // Set alert type to danger for error message
            setShowAlert(true);
        }
    };

    return (
        <div className='container-pass' style={{ paddingLeft: '15px' }}>
            <h1 style={{ marginTop: '60px', color: '#0353a4', textAlign: 'left', fontSize: '2rem' }}>
                <ImProfile style={{ marginRight: '10px' }} />Profile
            </h1>
            <hr />
            <h1 style={{ color: '#0353a4', textAlign: 'left', fontSize: '2rem' }}>
                <FaEdit style={{ marginRight: '10px' }} />Change Password
            </h1>
            <hr />
            {showAlert && (
                <Alert variant={alertType} onClose={() => setShowAlert(false)} dismissible>
                    {alertMessage}
                </Alert>
            )}
            <Form onSubmit={handleSubmit}
                  m
                  className='container'
                  style={{
                      width: '100%',
                      maxWidth: '900px',
                      padding: '20px',
                      borderRadius: '8px',
                      border: '8px solid #0353a4',
                      backgroundColor: '#bbdefb',
                      marginBottom: '100px',
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'left'
                  }}
            >
                <Form.Group controlId="inputOldPassword" className="text-left" style={{ width: '80%' }}>
                    <Form.Label style={{ fontWeight: 'bold' }}>Old Password:</Form.Label>
                    <Form.Control
                        type="password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        required
                        style={{ width: '100%', textAlign: 'left' }}
                    />
                </Form.Group>
                <Form.Group controlId="inputNewPassword" style={{ marginTop: '20px', width: '80%' }} className="text-left">
                    <Form.Label style={{ fontWeight: 'bold' }}>New Password:</Form.Label>
                    <Form.Control
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        style={{ width: '100%', textAlign: 'left' }}
                    />
                </Form.Group>
                <Form.Group controlId="inputConfirmPassword" style={{ marginTop: '20px', width: '80%' }} className="text-left">
                    <Form.Label style={{ fontWeight: 'bold' }}>Confirm New Password:</Form.Label>
                    <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        style={{ width: '100%', textAlign: 'left' }}
                    />
                </Form.Group>
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
                    <Button variant="primary" type="submit">
                        Reset Password
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default ResetPassword;
